import React from 'react';
import { NavLink, Navigate, Outlet, useLocation } from 'react-router-dom';
import Topbar from '@/layout/Topbar';
import { useShell } from '@/layout/AppShell';
import { useCan } from '@/auth/AuthContext';

// Подразделы настроек. У каждого свой ключ права (для гейта в навигации).
// Раздел services — кастомная страница, остальные — стандартная форма SettingsForm.
const SECTIONS = [
  { key: 'org',      label: 'Организация',      perm: 'settings.org' },
  { key: 'mail',     label: 'Почта (SMTP)',     perm: 'settings.mail' },
  { key: 'push',     label: 'Пуш-уведомления',  perm: 'settings.push' },
  { key: '1c',       label: '1С',               perm: 'settings.1c' },
  { key: '1c_zup',   label: '1С ЗУП',           perm: 'settings.1c_zup' },
  { key: 'receipt',  label: 'Чеки (ОФД)',       perm: 'settings.receipt' },
  { key: 'yookassa',   label: 'ЮКасса',         perm: 'settings.yookassa' },
  { key: 'modulkassa', label: 'Модулькасса',    perm: 'settings.modulkassa' },
  { key: 'dds',      label: 'Статьи ДДС',       perm: 'settings.dds' },
  { key: 'skud',         label: 'СКУД',             perm: 'settings.skud' },
  { key: 'data_lock', label: 'Запрет изменения данных', perm: 'settings.data_lock' },
  { key: 'api_log',  label: 'Лог API',           perm: 'settings.api_log' },
  { key: 'ad',       label: 'Active Directory', perm: 'settings.ad' },
  { key: 'exchange', label: 'Exchange',         perm: 'settings.exchange' },
  { key: 'telephony',label: 'Телефония (CDR)',  perm: 'settings.telephony' },
  { key: 'maps',     label: 'Карты (геокодер)', perm: 'settings.maps' },
  { key: 'ws',       label: 'WebSocket',        perm: 'settings.ws' },
  { key: 'services', label: 'Сервисы',          perm: 'services.manage' },
];

export default function SettingsPage() {
  const { tweaks, updateTweak } = useShell();
  const can = useCan();
  const location = useLocation();

  const visible = SECTIONS.filter((s) => can(s.perm, 'read'));

  // Если зашёл на /settings без подраздела — редирект на первый доступный.
  if (location.pathname === '/settings' || location.pathname === '/settings/') {
    if (visible.length === 0) {
      return <NoAccess />;
    }
    return <Navigate to={`/settings/${visible[0].key}`} replace />;
  }

  return (
    <>
      <Topbar
        breadcrumb={['Администрирование', 'Настройки']}
        density={tweaks.density}
        onDensityChange={(d) => updateTweak('density', d)}
      />
      <div className="settings-page">
        <aside className="settings-nav">
          <div className="settings-nav__title">Разделы</div>
          {SECTIONS.map((s) => {
            const allowed = can(s.perm, 'read');
            return (
              <NavLink
                key={s.key}
                to={`/settings/${s.key}`}
                className={({ isActive }) =>
                  'settings-nav__item' +
                  (isActive ? ' is-active' : '') +
                  (!allowed ? ' is-disabled' : '')
                }
                onClick={(e) => { if (!allowed) e.preventDefault(); }}
                title={allowed ? undefined : 'Нет доступа'}
              >
                {s.label}
                {!allowed && <span className="settings-nav__lock">нет доступа</span>}
              </NavLink>
            );
          })}
        </aside>
        <div className="settings-main">
          <Outlet />
        </div>
      </div>
    </>
  );
}

function NoAccess() {
  return (
    <div style={{ padding: 32, color: 'var(--fg)' }}>
      <h2 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>Настройки</h2>
      <p style={{ color: 'var(--fg-muted)' }}>У вас нет доступа ни к одному из подразделов настроек.</p>
    </div>
  );
}
